import useMutationApi from '../useMutationApi';

interface UpdateCustomerData {
  customerId: string;
}

const useUpdateSalesOrderDraftCustomer = (
  salesOrderDraftId: string,
  onSuccess?: () => void,
) => {
  return useMutationApi<UpdateCustomerData>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}/customer`,
    method: 'PUT',
    options: {
      onSuccess,
    },
  });
};

export default useUpdateSalesOrderDraftCustomer;
